import React, { useEffect, useMemo, useState } from "react";

import Select from "react-select";
import { CorporationStore } from "../corporation_master/CorporationStore";
import { DashBoardStore } from "./DashBoardStore";

import combinedMap from "../../../assets/images/GHMC-MMC-CMC_combined.png";
import ghmcMap from "../../../assets/images/GMC.png";
import mmcMap from "../../../assets/images/MMC_Malkajgiri.png";
import cmcMap from "../../../assets/images/CMC.png";
import CountUp from "react-countup";
import DashboardCardLoader from "../../Common/DashboardCardLoader/DashboardCardLoader";

const mapRegionOptions = [
  { value: "all", label: "All", image: combinedMap },
  { value: "ghmc", label: "GHMC", image: ghmcMap },
  { value: "mmc", label: "MMC", image: mmcMap },
  { value: "cmc", label: "CMC", image: cmcMap },
];

const getRegionFromUserCorporations = (userCorporations) => {
  if (!Array.isArray(userCorporations) || userCorporations.length === 0) return "all";
  const normalized = userCorporations
    .map((c) => (c.corporationName || c.name || "").toString().trim().toLowerCase())
    .filter(Boolean);
  const regions = new Set();
  normalized.forEach((name) => {
    if (name.includes("ghmc") || name.includes("gmc")) regions.add("ghmc");
    else if (name.includes("mmc")) regions.add("mmc");
    else if (name.includes("cmc")) regions.add("cmc");
  });
  if (regions.size === 1) return regions.values().next().value;
  return "all";
};

const selectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: "0px",
    backgroundColor: "#ececec",
    border: "1px solid #dee2e6",
    boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(0,123,255,0.25)" : "none",
    borderColor: state.isFocused ? "#80bdff" : "#ced4da",
    minHeight: "38px",
    fontSize: "1rem",
    "&:hover": { borderColor: "#ced4da" },
  }),
  valueContainer: (base) => ({ ...base, padding: "0px 8px" }),
  placeholder: (base) => ({ ...base, color: "#6c757d", fontSize: "1rem", marginLeft: "6px" }),
  indicatorSeparator: (base) => ({ ...base, backgroundColor: "#fff" }),
  dropdownIndicator: (base) => ({ ...base, padding: "6px", color: "#6c757d" }),
};

const AssetDashboard = () => {
  const { fetchCorporationDetails, fetchUserCorporations, UserCorporations } = CorporationStore();
  const { fetchAssetDashboardDetails, AssetDashboardDetails,isAssetDashboardLoading } = DashBoardStore();
  const [hoveredCard, setHoveredCard] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState("all");
  const [hasRegionInitialized, setHasRegionInitialized] = useState(false);

  useEffect(() => {
    fetchCorporationDetails();
    fetchUserCorporations();
    fetchAssetDashboardDetails();
  }, []);

  useEffect(() => {
    if (!hasRegionInitialized && UserCorporations.length > 0) {
      setSelectedRegion(getRegionFromUserCorporations(UserCorporations));
      setHasRegionInitialized(true);
    }
  }, [UserCorporations, hasRegionInitialized]);

  const visibleRegionOptions = useMemo(() => {
    if (!UserCorporations || UserCorporations.length === 0) return mapRegionOptions;
    const normalized = UserCorporations
      .map((c) => (c.corporationName || c.name || "").toString().trim().toLowerCase())
      .filter(Boolean);
    const regions = new Set();
    normalized.forEach((name) => {
      if (name.includes("ghmc") || name.includes("gmc")) regions.add("ghmc");
      else if (name.includes("mmc")) regions.add("mmc");
      else if (name.includes("cmc")) regions.add("cmc");
    });
    const individual = mapRegionOptions.filter((o) => o.value !== "all" && regions.has(o.value));
    return individual.length > 1 ? [mapRegionOptions[0], ...individual] : individual;
  }, [UserCorporations]);

  const activeRegion =
    visibleRegionOptions.find((o) => o.value === selectedRegion) ||
    visibleRegionOptions[0] ||
    mapRegionOptions[0];

  const AssetCards = [
    {
      title: "Count of Bins",
      value:
       AssetDashboardDetails.bins || 0,
      accent: "#4A90D9",
    },
    {
      title: "Count of vehicles",
      value:
      AssetDashboardDetails.vehicles || 0,
      accent: "#27AE60",
    },
    {
      title: "Count of Containers",
      value:
      AssetDashboardDetails.container || 0,
      accent: "#E67E22",
    },
    {
        title: "Count of TS/SCTP's",
        value:
        AssetDashboardDetails.transferStation || 0,
        accent: "#16A085",
      },
      {
        title: "Count of Bio metric devices",
        value:
        AssetDashboardDetails.biometricDevices || 0,
        accent: "#2980B9",
      },
      {
        title: "Count of RFID tags",
        value:
        AssetDashboardDetails.rfidTags ||0,
        accent: "#2C3E50",
      },
      {
        title: "Count of RFID readers",
        value:
        AssetDashboardDetails.rfidReaders ||0,
        accent: "#ec1117",
      },
  ];

  return (
    <div style={{ width: "100%" }}>
      <div className="content">
        <div className="page-content">
          <h4 className="text-start mb-3">Asset Dashboard</h4>
         
              {isAssetDashboardLoading ?  <DashboardCardLoader count={7} /> : null}

          <div className="row mt-3 g-3">
            {!isAssetDashboardLoading &&AssetCards.map((card, index) => {
              const isHovered = hoveredCard === index;
              return (
                <div className="col-md-4" key={index}>
                  <div
                    className="card border-0"
                    onMouseEnter={() => setHoveredCard(index)}
                    onMouseLeave={() => setHoveredCard(null)}
                    style={{
                      borderRadius: "12px",
                      background: "#f8f9fa",
                      boxShadow: isHovered
                        ? "0 12px 28px rgba(0,0,0,0.15)"
                        : "0 2px 8px rgba(0,0,0,0.08)",
                      transform: isHovered
                        ? "translateY(-6px) scale(1.02)"
                        : "translateY(0) scale(1)",
                      transition: "all 0.25s ease",
                      cursor: "pointer",
                    }}
                  >
                    <div className="card-body" style={{ padding: "20px 24px" }}>
                      <div
                        style={{
                          width: "40px",
                          height: "4px",
                          backgroundColor: card.accent,
                          borderRadius: "2px",
                          marginBottom: "14px",
                        }}
                      />
                      <p
                        className="mb-1"
                        style={{
                          fontSize: "13px",
                          color: "#6c757d",
                          fontWeight: 500,
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        {card.title}
                      </p>
                      <h3
                        className="mb-0"
                        style={{
                          color: card.accent,
                          fontWeight: 700,
                        }}
                      >
                      
                       <CountUp  end={card.value} duration={3} />
                      </h3>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="card mb-3">
              <div className="card-body">
                <style>{`@keyframes fadeIn { from { opacity: 0; transform: scale(0.98); } to { opacity: 1; transform: scale(1); } }`}</style>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "16px",
                    marginBottom: "20px",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span style={{ fontSize: "14px", fontWeight: 600, color: "#2c3e50" }}>
                      Select Region
                    </span>
                    <div style={{ minWidth: "220px" }}>
                      <Select
                        options={visibleRegionOptions}
                        value={activeRegion}
                        onChange={(sel) => setSelectedRegion(sel.value)}
                        isSearchable={false}
                        styles={selectStyles}
                      />
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                    {visibleRegionOptions.map((o) => {
                      const isActive = o.value === selectedRegion;
                      return (
                        <button
                          key={o.value}
                          type="button"
                          onClick={() => setSelectedRegion(o.value)}
                          style={{
                            border: isActive ? "1px solid #8E44AD" : "1px solid #dee2e6",
                            background: isActive ? "#8E44AD" : "#fff",
                            color: isActive ? "#fff" : "#6c757d",
                            padding: "6px 16px",
                            borderRadius: "20px",
                            fontSize: "13px",
                            fontWeight: 600,
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                        >
                          {o.label}
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div
                  style={{
                    position: "relative",
                    borderRadius: "12px",
                    overflow: "hidden",
                    background: "linear-gradient(135deg, #f8f9fa 0%, #eef1f5 100%)",
                    border: "1px solid #e9ecef",
                    padding: "16px",
                    textAlign: "center",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      top: "16px",
                      left: "16px",
                      background: "#8E44AD",
                      color: "#fff",
                      padding: "4px 14px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: 700,
                      letterSpacing: "0.5px",
                      boxShadow: "0 2px 8px rgba(142,68,173,0.3)",
                    }}
                  >
                    {activeRegion.label}
                  </span>
                  <img
                    key={activeRegion.value}
                    src={activeRegion.image}
                    alt={`${activeRegion.label} map`}
                    style={{
                      width: "100%",
                      maxHeight: "720px",
                      objectFit: "contain",
                      animation: "fadeIn 0.4s ease",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssetDashboard;

const getStartOfCurrentDate = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}T00:00`;
};
